import { DecimalPipe } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemProgressComponent } from '../../components/item-progress/item-progress.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-condition-info',
	templateUrl: './modal-condition-info.component.html',
	imports: [ CommonModule, DecimalPipe, TranslatePipe, ItemProgressComponent, LoaderOverlayComponent, FormsModule ]
})
export class ModalConditionInfoComponent implements OnInit {
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalConditionInfoComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.getExplanations();
		
		this.vm.close = this.close;
	}
	
	getExplanations() {
		var interview: any = this.angularHelperService.copy(this.vm.interview);
		interview.target = this.vm.condition?.condition
			? this.angularHelperService.copy(this.vm.condition.condition.id)
			: this.angularHelperService.copy(this.vm.condition.id);
		
		this.restService.saveInterviewExplanation(this.vm.interview).then(
			(res) => {
				this.vm.evidence = res;
				this.vm.isInitialized = true;
			}
		)
		.catch(console.error);
	}
	
	close() {
		this.dialogRef.close();
	}
	
}